/* eslint-disable multiline-comment-style */
/* eslint-disable camelcase */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';

// main components below
import Filter from './components/Filter';
import ModalAddRecord from './AddRecord';
import ViewRecord from './view';
// import UserClearance from './UserClearance';
import CaseHistoryActionTable from './components/Table';
import { selectPatientData } from 'reducers/patientReducer';

// import assets below
import './style.scss';

// main component
const CaseHistory = () => {
  // eslint-disable-next-line no-unused-vars
  const [showModal, setShowModal] = useState({
    addModal: false,
    isProfileShow: false,
    isViewStatus: false,
    profileData: null,
    profileId: null,
    viewRecordModal: false,
  });

  const data = useSelector(selectPatientData);

  const [filter, setFilter] = useState({
    physician_name: '',
    case_id: '',
    date: '',
  });

  const [filteredData, setFilteredData] = useState([]);

  return (
    <>
      <div className='case-history mt-4'>
        {!showModal.isProfileShow ? (
          <>
            <Filter
              data={data}
              filter={filter}
              setFilter={setFilter}
              setFilteredData={setFilteredData}
            />

            <div className='case-history-list'>
              <div className='header-cont d-flex justify-content-between align-items-center'>
                <h5 className='fw-bold mb-3'>Patient List</h5>

                <Button
                  onClick={() => {
                    setShowModal((prevState) => {
                      return {
                        ...prevState,
                        addModal: true,
                      };
                    });
                  }}
                >
                  ADD RECORD
                </Button>
              </div>
              {!showModal.isViewStatus ? (
                <CaseHistoryActionTable
                  data={data}
                  filter={filter}
                  filteredData={filteredData}
                  setShowModal={setShowModal}
                />
              ) : (
                // <StatusClearanceListTable setShowModal={setShowModal} />
                <>View Action Here</>
              )}
            </div>
          </>
        ) : (
          <>Test Here</>
          // <UserClearance showModal={showModal} setShowModal={setShowModal} />
        )}
      </div>
      <ViewRecord showModal={showModal} setShowModal={setShowModal} />
      <ModalAddRecord showModal={showModal} setShowModal={setShowModal} />
    </>
  );
};

export default CaseHistory;
